import { combineReducers } from 'redux';

const INITIAL_STATE = {
    loading: false,
    error: null,
    tasks: [],
    createdJobs: [],
    inprogressJobs: [],
    completedJobs: []
};

const tasksReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case 'SET_TASKS':
            return { ...state, tasks: action.tasks };
        case 'SET_CREATED_TASKS':
            return { ...state, createdJobs: action.tasks };
        case 'SET_INPROGRESS_TASKS':
            return { ...state, inprogressJobs: action.tasks };
        case 'SET_COMPLETED_TASKS':
            return { ...state, completedJobs: action.tasks };
        case 'SET_LOADING':
            return { ...state, loading: action.flag };
        case 'SET_ERROR':
            return { ...state, error: action.error };
        case 'LOG_OUT':
            return { INITIAL_STATE };
        default:
            return state;
    }
};

export default tasksReducer;